import { api } from "api/base-config";
import { StatusTypeEnum } from "common/enums/StatusTypeEnum";
import { DateMaskEnum } from "common/enums/DateMaskEnum";
import { ConfidentialityTypeEnum } from "common/enums/ConfidentialityTypeEnum";
import moment from "moment";
import {
  SubContactItem,
  SubContactItemType
} from "common/models/SubContactItem";

/** ---- API ---- */
export const createEmptySubContact = (
  patientId: number,
  caregiverId: number,
  contactId: number
): Promise<SubContactItemType> => {
  return api
    .post(
      `/resources/secured/rs/caregivers/${caregiverId}/patients/${patientId}/subContacts`,
      emptySubContact(contactId)
    )
    .then(response => mapToSubContactItemType(response.data));
};

/** ---- Mapper ---- */
const mapToSubContactItemType = (dto: SubContactDTO): SubContactItemType => {
  return Object.assign(new SubContactItem(), {
    id: dto.id,
    contactID: dto.contactID,
    dto: dto
  });
};

const emptySubContact = (contactId: number): SubContactDTO => {
  return {
    "@type": "SubContact",
    id: -1,
    actionDate: moment().toDate(),
    actionDateMask: DateMaskEnum.DDMMYYYYHHMMSS,
    confidentiality: ConfidentialityTypeEnum.C6,
    contactID: contactId,
    hidden: false,
    status: StatusTypeEnum.ACTIVE,
    title: ""
  };
};

/** ---- DTO ---- */
interface SubContactDTO {
  readonly "@type": "SubContact";
  readonly id: number;
  readonly actionDate: Date;
  readonly confidentiality: ConfidentialityTypeEnum;
  readonly actionDateMask: DateMaskEnum;
  readonly status: StatusTypeEnum;
  readonly title: string;
  readonly hidden: boolean;
  readonly contactID: number;
}
